import Comp from "./Lidarseg";

export default Comp;
